import saMessages from '../locales/ko_KR.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  locale: 'ko-KR',
};
export default saLang;
